import type { ErrorLike } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import { SPAN_REMOVE_MOBILE_SERVICE } from '@constants/otel';
import { ProductType } from '@generated/gql/graphql';
import { useSnackbarError } from '@hooks/useSnackbarErrors';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useUpdatedTariffModalContext } from '@providers/basket/UpdatedTariffModalProvider/Context';
import { useTrace } from '@services/otel';
import { UpdatedTariffModalVariant } from '@src/types/bundle';
import { deselectMobileMutation } from '@utils/queries/mobile';

const useRemoveMobileService = () => {
  const { withTrace } = useTrace();
  const { basketId } = useBasketContext();
  const setSnackbarError = useSnackbarError();
  const { setModalState } = useUpdatedTariffModalContext();

  const [deselectMobile, { loading }] = useMutation(deselectMobileMutation);

  const executeRemoveService = async (onComplete?: () => void) => {
    try {
      await deselectMobile({
        variables: {
          basketId,
        },
      });
      setModalState(UpdatedTariffModalVariant.productRemoved, [
        ProductType.Mobile,
      ]);
      onComplete?.();
    } catch (error) {
      setSnackbarError(error as ErrorLike);
    }
  };

  const removeService = (quoteCount: number, onComplete: () => void) =>
    withTrace(
      SPAN_REMOVE_MOBILE_SERVICE,
      () => executeRemoveService(onComplete),
      { quoteCount }
    );

  return { isLoading: loading, removeService };
};

export { useRemoveMobileService };
